(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-features-list"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.features-list__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.previousElementSibling;
      var isExpanded = list.classList.toggle('expanded');
      btn.classList.toggle('expanded');
      
      var textEl = btn.querySelector('.features-list__toggle-text');
      if (textEl) {
        textEl.textContent = isExpanded 
          ? (btn.getAttribute('data-hide-label') || 'Show Less')
          : (btn.getAttribute('data-show-label') || 'Show More');
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
